import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';
import {
  Checkbox as SemanticCheckbox,
  CheckboxProps as SemanticCheckboxProps,
} from 'semantic-ui-react';

export interface CheckboxProps extends Omit<SemanticCheckboxProps, 'onChange'> {
  labelLeft?: boolean;
  onChange?: (checked: boolean, value: string | number | undefined) => void;
  onCheckBoxChanged?: (e: React.FormEvent<HTMLInputElement>, value: boolean) => void;
}

const Checkbox = styled<React.FC<CheckboxProps>>(
  ({ className, labelLeft, label = '', onChange, onCheckBoxChanged, value, checked, ...props }) => {
    const disabled = props.disabled || false;
    return (
      <SemanticCheckbox
        className={className}
        css={[
          labelLeft
            ? css`
                > input {
                  ~ label {
                    padding-left: 0 !important;
                    padding-right: 1.75rem !important;
                    &::before {
                      right: -0rem;
                      left: auto !important;
                      transition: all 0.1s ease !important;
                    }
                    &::after {
                      right: 1.05rem;
                      left: auto !important;
                      transition: all 0.1s ease !important;
                    }
                  }
                  &:checked {
                    ~ label {
                      &::after {
                        right: -0.05rem;
                      }
                    }
                  }
                }
              `
            : '',
        ]}
        onChange={(e, value): void => {
          onCheckBoxChanged && onCheckBoxChanged(e, Boolean(value.checked));
          onChange && onChange(Boolean(value.checked), value.value);
        }}
        label={label}
        disabled={disabled}
        type='checkbox'
        onClick={(e): void => e.currentTarget.focus()}
        checked={checked || Boolean(value)}
      />
    );
  }
)`
  label {
    padding-left: 1.6rem !important;
    padding-top: 0 !important;
    &:before {
      border: 1px solid #979797 !important;
    }
    &:after {
      color: #36969b !important;
    }
  }
`;

export default Checkbox;
